import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const useStyles = makeStyles(() => {
    return createStyles({
        icon: {
            fontSize: 16,
            display: 'block',
            marginLeft: 0,
        },
        unspecified: {
            color: palette.error.main,
        },
        open: {
            color: palette.warning.main,
        },
        purple: {
            color: palette.primary.light,
        },
    })
})
